<template>
  <div class="util-latest-list">
    <div class="util-card" v-for="(row,i) in listdata" :key="i">
      <div class="util-card-date">
        <strong>{{ dayjs(row.date).format("D") }}</strong>
        <span>{{ dayjs(row.date).format("MMM") }}</span>
        <span>{{ dayjs(row.date).format("YYYY") }}</span>
      </div>
      <div class="util-card-detail ucdl">
        <div class="ucdl-item">
          <span>Sparepart</span>
          <p>
            <strong v-if="row.sparepart">{{ row.sparepart?.item_name }} ({{ row.sparepart?.sparepart_no }})</strong>
            <strong v-else>-</strong>
          </p>
        </div>
        <div class="ucdl-item">
          <span>Qty</span>
          <p>
            <strong>{{ row.qty ?? '-' }}</strong>
          </p>
        </div>
        <div class="ucdl-item">
          <span>Mesin</span>
          <p>
            <strong v-if="row.machine">{{ row.machine?.name ?? '-' }} ({{ row.machine?.code }})</strong>
            <strong v-else>-</strong>
          </p>
        </div>

      </div>
    </div>
  </div>
</template>


<script lang="js">
import Vue from "vue";
import dayjs from "dayjs";
import { Prop } from "vue-property-decorator";
import { Component } from "vue-property-decorator";
import { nom  } from "@/api/api";
@Component({})
export default class UtilitiesListrikList extends Vue {
  @Prop () listdata;
  dayjs = dayjs
  nom = nom
}
</script>
